import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { X, ArrowLeft, Printer, LoaderCircle } from "lucide-react";
import { APIUtility, APIEND_POINT } from "../Api";
import Loader from "../components/Common/Loader";
import ImageWithRect from "../components/Common/ImageWithRect"

const QrCodeDetailsModal = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [captureStatus, setCaptureStatus] = useState("capture");
  const [isPrinting, setIsPrinting] = useState(false);
  const [printStatus, setPrintStatus] = useState("initial");
  const [qrCodeDetails, setQrCodeDetails] = useState(null);

  const { show, onHide, qrcodeId } = props;

  useEffect(() => {
    setCaptureStatus("capture");
    setPrintStatus("initial");
    if (show) {
      fetchQrCodeDetails();
    }
  }, [show]);

  const fetchQrCodeDetails = async () => {
    setIsLoading(true);
    try {
      const body = { user_vehicle_mapping_id: qrcodeId };

      const res = await APIUtility.GetQrCodeDetails(body);

      if (res.status == 200) {
        setQrCodeDetails(res.data); // Set state with fetched data

        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error in fetching QR code details:", error);
      setIsLoading(false);
    }
  };

  const handlePrintQRCode = async () => {
    setIsPrinting(true);
    try {
      const response = await APIUtility.printQRCode({
        user_vehicle_mapping_id: qrcodeId
      });

      if (response.status === 200) {
        setPrintStatus("printed");
      }
    } catch (error) {
      console.error("Error printing QR code:", error);
    } finally {
      setIsPrinting(false);
    }
  };

  return (
    <div>
      <Modal
        show={show}
        onHide={onHide}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body className="!p-0">
          <button
            className=" absolute right-[10px] top-[10px] text-black"
            onClick={() => onHide()}
          >
            <X size={26} />
          </button>
          {isLoading ? (
            <div className="flex items-center justify-center h-[60vh]">
              <Loader />
            </div>
          ) : (
            <div className=" flex  h-full w-full">
              <div className=" w-[68%] bg-[#F9F9F7] py-[20px] px-[20px] rounded-s-xl">
                <div className="flex flex-col h-full">
                  <h3 className="flex items-center gap-3 font-bold text-[18px] select-none">
                    <ArrowLeft
                      className=" cursor-pointer"
                      onClick={() => onHide()}
                    />{" "}
                    Capture Vehicle No. Plate
                  </h3>

                  <div className="w-full h-screen_h_350 flex-grow pt-2 relative select-none">
                    <ImageWithRect
                      data={{
                        img: APIEND_POINT + qrCodeDetails?.vehicle_image,
                        label: qrCodeDetails?.vechicle_info?.license_plate,
                        ...qrCodeDetails?.vechicle_info,
                        show,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="w-[32%] py-[20px] px-[20px] ">
                <h3 className="flex items-center gap-3 font-bold text-[18px] select-none">
                  QR Code And Details
                </h3>

                <div
                  className="py-2 px-[0px] rounded-[5px] flex items-center flex-col justify-center w-full"
                  style={{ background: "rgba(196, 196, 196, 0.10)" }}
                >
                  <div className="w-[100%] flex items-center justify-center ">
                    <img
                      className="w-auto h-[150px] lgLp:h-[250px] object-fill select-none"
                      src={APIEND_POINT + qrCodeDetails?.qr_image}
                      alt="QR Code"
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 mt-3">
                  <div className="xl:h-[55px] border-b flex items-center  justify-between">
                    <h4 className="text-[15px] font-medium text-[#000000] opacity-[0.6]">
                      QR Code :
                    </h4>
                    <h2 className=" text-[14px] font-medium text-black break-normal">
                      {qrCodeDetails?.qr_data || "-"}
                    </h2>
                  </div>
                  <div className="xl:h-[50px] border-b flex items-center justify-between">
                    <h4 className="text-[15px] font-medium text-[#000000] opacity-[0.6]">
                      Vehicle No. :
                    </h4>

                    <h2 className=" text-[14px] font-medium text-black break-normal">
                      {qrCodeDetails?.vechicle_info?.license_plate || "-"}
                    </h2>
                  </div>
                  <div className="xl:h-[50px] border-b flex items-center justify-between">
                    <h4 className="text-[15px] font-medium text-[#000000] opacity-[0.6]">
                      Date and Time :
                    </h4>
                    <h2 className=" text-[14px] font-medium text-black break-normal">
                      {qrCodeDetails?.date || "-"} {qrCodeDetails?.time || "-"}
                    </h2>
                  </div>
                </div>
                <button
                  onClick={handlePrintQRCode}
                  disabled={isPrinting || printStatus === "printed"}
                  className={`mx-auto mt-[15px] rounded-[3px] flex items-center justify-center gap-2 font-bold text-[16px] px-4 h-[47px] transition-all
                    ${printStatus === "printed"
                      ? "bg-green-50 text-green-600 hover:text-green-700 [&_svg]:hover:text-green-700 border-2 border-green-600"
                      : "bg-[#F5F5F5] hover:bg-[#EBEBEB]"
                    }`}
                >
                  {isPrinting ? (
                    <>
                      <LoaderCircle className="animate-spin" size={23} /> Printing...
                    </>
                  ) : printStatus === "printed" ? (
                    <>
                      <Printer className="text-green-600 transition-colors" /> QR Code Printed
                    </>
                  ) : (
                    <>
                      <Printer /> Print QR Code
                    </>
                  )}
                </button>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default QrCodeDetailsModal;
